import React from 'react';
import ModernTemplate from './templates/ModernTemplate';
import ClassicTemplate from './templates/ClassicTemplate';
import MinimalistTemplate from './templates/MinimalistTemplate';
import CreativeTemplate from './templates/CreativeTemplate';
import ProfessionalTemplate from './templates/ProfessionalTemplate';

import { useSubscription } from '../contexts/SubscriptionContext';

const PreviewPanel = ({ resumeData, selectedTemplate }) => {
    const { isPremium, hasFeature, purchaseFeature, getFeaturePrice } = useSubscription();

    // Dynamic Pricing
    const watermarkPrice = getFeaturePrice('remove_branding');

    return (
        <div className="flex-1 bg-slate-500 relative flex flex-col overflow-hidden">
            {/* Watermark Overlay (Fixed at top of panel) */}
            {!isPremium && !hasFeature('remove_branding') && (
                <div className="absolute inset-x-0 top-0 py-2 bg-slate-900/50 backdrop-blur-sm z-20 flex justify-between items-center px-4 text-white text-xs">
                    <span className="opacity-80">Created with Resume Architect</span>
                    <button
                        onClick={() => purchaseFeature('remove_branding', watermarkPrice)}
                        className="bg-white/10 hover:bg-white/20 text-white font-bold px-3 py-1 rounded transition-colors"
                    >
                        Remove Watermark (${watermarkPrice})
                    </button>
                </div>
            )}

            {/* Scrollable Content Area */}
            <div className="flex-1 overflow-y-auto p-4 md:p-8 preview-container">
                {selectedTemplate === 'modern' && <ModernTemplate resumeData={resumeData} />}
                {selectedTemplate === 'classic' && <ClassicTemplate resumeData={resumeData} />}
                {selectedTemplate === 'minimalist' && <MinimalistTemplate resumeData={resumeData} />}
                {selectedTemplate === 'creative' && <CreativeTemplate resumeData={resumeData} />}
                {selectedTemplate === 'professional' && <ProfessionalTemplate resumeData={resumeData} />}
            </div>
        </div>
    );
};

export default PreviewPanel;
